import { useEffect, useState } from 'react';

/** The time in ms, ticking every second while `running`; held at its last value otherwise. */
export const useClock = (running: boolean): number => {
	const [now, setNow] = useState(() => Date.now());
	useEffect(() => {
		if (!running) {
			return undefined;
		}
		setNow(Date.now());
		const timer = window.setInterval(() => setNow(Date.now()), 1000);
		return () => window.clearInterval(timer);
	}, [running]);
	return now;
};
